import { render, staticRenderFns } from "./MoneyOrders.vue?vue&type=template&id=67b9f201"
import script from "./MoneyOrders.vue?vue&type=script&lang=js"
export * from "./MoneyOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports